import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from '@react-pdf/renderer';

import Logo from "../../../images/logo.png";

const appUrl = process.env.REACT_APP_URL_BACKEND;

// ---------- ESTILOS ----------
const styles = StyleSheet.create({
    page: { padding: 20, fontSize: 10, fontFamily: 'Helvetica' },

    header: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#ccc',
        borderBottomStyle: 'solid',
        paddingBottom: 10,
    },

    image: { width: 120, height: 50, marginRight: 15 },

    headerTextContainer: {
        flex: 1,
        alignItems: 'center',
    },

    title: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
    },

    subTitle: {
        fontSize: 9,
        textAlign: 'center',
        marginTop: 2
    },

    // ========== CELDAS AL ESTILO FORMULARIO ==========
    formRow: {
        flexDirection: "row",
        gap: 1,
        marginBottom: 1,
    },

    formCell: {
        flex: 1,
        borderWidth: 1,
        borderColor: "#555",
        borderStyle: "solid",
        padding: 5,
    },

    // --- NUEVA CORRECCIÓN PARA QUE SIEMPRE SEAN INLINE ---
    infoInline: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        flexShrink: 1,
        wrap: false,
    },

    infoInlineLabel: {
        fontSize: 10,
        fontWeight: "bold",
        marginRight: 4,
        flexShrink: 0
    },

    infoInlineValue: {
        fontSize: 10,
        textAlign: "right",
        flexShrink: 1,
        maxWidth: "70%"
    },

    // ========== TABLA ==========
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        fontSize: 9,
        marginTop: 15
    },

    tableRow: { flexDirection: "row" },

    tableColHeader: {
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: "#eee",
        padding: 4,
    },

    tableCol: {
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 4,
    },

    tableCellHeader: { fontWeight: "bold" },

    totalRow: {
        marginTop: 10,
        flexDirection: "row",
        justifyContent: "flex-end",
        paddingRight: 10
    }
});


// ---------- PAGINAR ----------
const paginateRows = (rows, rowsPerPage = 30) => {
    const pages = [];
    for (let i = 0; i < rows.length; i += rowsPerPage) {
        pages.push(rows.slice(i, i + rowsPerPage));
    }
    return pages;
};

// ---------- DOCUMENTO PDF ----------
const PDFDoc = ({ cabecera, columns, rows, titlePdf, empresa }) => {
    const rowsPerPage = 30;
    const paginatedRows = paginateRows(rows, rowsPerPage);

    const imageUrl = empresa?.imagen_sitio
        ? `${appUrl}${empresa.imagen_sitio}`
        : Logo;

    // ========== CALCULOS AUTOMATICOS ==========

    // Cantidad de ítems = número de filas
    const totalItems = rows.length;

    // Total de unidades = suma de cantidad
    const totalUnidades = rows.reduce(
        (acc, r) => acc + Number(r.quantity || 0),
        0
    );

    const subtotal = Number(cabecera?.total.toFixed(2));

    // Total con descuento (viene de cabecera)
    const totalConDescuentoRaw = Number(cabecera?.totaldesc || 0);
    const totalConDescuento = Number(totalConDescuentoRaw.toFixed(2));

    // Descuento en pesos
    const descuentoPesosRaw = subtotal - totalConDescuento;
    const descuentoPesos = Number(descuentoPesosRaw.toFixed(2));

    // Porcentaje de descuento
    const descuentoPorcentajeRaw =
        subtotal > 0 ? (descuentoPesos / subtotal) * 100 : 0;
    const descuentoPorcentaje = Number(descuentoPorcentajeRaw.toFixed(2));

    // Total final
    const total = totalConDescuento;
    const trimText = (txt, max = 30) =>
    txt && txt.length > max ? txt.substring(0, max) + "…" : txt;


    return (
        <Document>
            {paginatedRows.map((pageRows, pageIndex) => (
                <Page key={pageIndex} size="A4" style={styles.page}>

                    {/* ENCABEZADO */}
                    <View style={styles.header}>
                        <Image src={imageUrl} style={styles.image} />
                        <View style={styles.headerTextContainer}>
                            <Text style={styles.title}>
                                {empresa.nombre_sitio} - {titlePdf}
                            </Text>
                            <Text style={styles.subTitle}>Dirección: {empresa.domicilio_sitio}</Text>
                            <Text style={styles.subTitle}>Teléfono: {empresa.telefonos_sitio}</Text>
                        </View>
                    </View>

                    {/* FILA 1 */}
                    <View style={styles.formRow}>
                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Pedido Nº:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.pedido}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Vendedor:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.vendedor}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Fecha:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.fecha}</Text>
                            </View>
                        </View>
                    </View>

                    {/* FILA 2 */}
                    <View style={styles.formRow}>
                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Código:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.codcliente}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Cliente:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.cliente}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Categoría:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.categoria}</Text>
                            </View>
                        </View>
                    </View>

                    {/* FILA 3 */}
                    <View style={styles.formRow}>
                        <View style={{ ...styles.formCell, flex: 2 }}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Dirección:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.direccion}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Teléfono:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.telefono}</Text>
                            </View>
                        </View>
                    </View>

                    {/* TABLA */}
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            {columns.map((h, i) => (
                                <View key={i} style={{ ...styles.tableColHeader, width: h.width }}>
                                    <Text style={styles.tableCellHeader}>{h.headerName}</Text>
                                </View>
                            ))}
                        </View>

                        {pageRows.map((row, rowIndex) => (
                            <View key={rowIndex} style={styles.tableRow}>
                                {columns.map((h, colIndex) => (
                                    <View key={colIndex} style={{ ...styles.tableCol, width: h.width }}>
                                        <Text>
                                            {h.field === "index"
                                                ? pageIndex * rowsPerPage + rowIndex + 1
                                                : ["art_descripcion", "observacion"].includes(h.field)
                                                    ? trimText(String(row[h.field] ?? ""), 30)
                                                    : String(row[h.field] ?? "")}
                                        </Text>

                                    </View>
                                ))}
                            </View>
                        ))}
                    </View>

                    {/* TOTALES */}
                    <View style={styles.formRow}>
                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Forma de Pago:</Text>
                                <Text style={styles.infoInlineValue}>{cabecera.formapago}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Cantidad de Items:</Text>
                                <Text style={styles.infoInlineValue}>{totalItems}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Total de Unidades:</Text>
                                <Text style={styles.infoInlineValue}>{totalUnidades} u</Text>
                            </View>
                        </View>
                    </View>


                    <View style={styles.formRow}>
                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Subtotal:</Text>
                                <Text style={styles.infoInlineValue}>${subtotal.toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Descuento: {descuentoPorcentaje.toFixed(2)}% </Text>
                                <Text style={styles.infoInlineValue}>${descuentoPesos.toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={styles.formCell}>
                            <View style={styles.infoInline}>
                                <Text style={styles.infoInlineLabel}>Total:</Text>
                                <Text style={styles.infoInlineValue}>${total.toFixed(2)}</Text>
                            </View>

                        </View>
                    </View>

                    {/* PIE */}
                    <Text
                        style={{
                            position: "absolute",
                            bottom: 20,
                            textAlign: "center",
                            width: "100%",
                            fontSize: 9,
                            color: "#888"
                        }}
                    >
                        Página {pageIndex + 1} de {paginatedRows.length}
                    </Text>
                </Page>
            ))}
        </Document>
    );
};

export default PDFDoc;
